import { useContext } from "react";
import BaseContext from "../contexts/BaseProvider";
const useBaseData = () => {
    const data = useContext(BaseContext);
    return data;
};
export default useBaseData;
